import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerInsightMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('insights', locale)
}
